import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppHeader from '../app-header';
import DocumentInfo from '../document-info/documentInfo';
import ExpandableTextBox from '../shared/expandableTextBox';
import { addLineBreak, DocumentInfoSection } from './documentInfoSection';

const DocumentPage = () => {
  const { id } = useParams();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`/api/document/${encodeURIComponent(id)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Document not found (${response.status})`);
        }
        return response.json();
      })
      .then(data => {
        setDocument(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  const renderContent = () => {
    if (loading) {
      return <div>Loading document...</div>;
    }

    if (error) {
      return <div>Error: {error}</div>;
    }

    if (!document) {
      return <div>No document found</div>;
    }

    return (
      <div className="layout__content-main">
        <div>
          <span className="layout__content-top-doc-h3" title={document.name}>
            {document.name.toUpperCase()}
          </span>
        </div>
        <DocumentInfoSection
          key={`${document.name}_document`}
          ingressProps={{ id: document.id, ...document.version_info }}
        >
          <DocumentInfo
            title="Why | Definition"
            content={addLineBreak(document.doc_functional_definition)}
          />
          <DocumentInfo
            title="What | Content Definition"
            content={addLineBreak(document.doc_content_definition)}
            hasTallContent={true}
          />
          <ExpandableTextBox
            title="What | Context (Additional Details)"
            content={addLineBreak(document.additional_details)}
            isExpanded={!!document.additional_details}
          />
          <ExpandableTextBox
            title="Project Phase Justification"
            content={addLineBreak(document.phase_project_justification)}
            isExpanded={!!document.phase_project_justification}
          />
          <ExpandableTextBox
            title="Operation Phase Justification"
            content={addLineBreak(document.phase_operation_justification)}
            isExpanded={!!document.phase_operation_justification}
          />
        </DocumentInfoSection>
      </div>
    );
  };

  return (
    <div className="layout__root">
      <div className="layout__head">
        <AppHeader />
      </div>
      <div className="layout__body">
        <div className="layout__content col-12 grey-bg">{renderContent()}</div>
      </div>
    </div>
  );
};

export default DocumentPage;
